import { Effect } from 'redux-saga/effects';

export interface INavigationServiceStrategy {
  triggerSuccessModalDisplay(): IterableIterator<Effect | null>;
}

export class NavigationService {
  public static getInstance() {
    if (!NavigationService._instance) {
      NavigationService._instance = new NavigationService();
    }

    return NavigationService._instance;
  }

  private static _instance: NavigationService;
  private _strategy: INavigationServiceStrategy;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public set strategy(value: INavigationServiceStrategy) {
    this._strategy = value;
  }
  public get strategy(): INavigationServiceStrategy {
    if (!this._strategy) {
      throw new Error(
        'affiny-core/services/navigation.ts you cannot call .strategy before configure it. Search NavigationService.strategy setter method'
      );
    }

    return this._strategy;
  }

  public *triggerSuccessModalDisplay() {
    return yield* this.strategy.triggerSuccessModalDisplay();
  }
}

export const navigationService = NavigationService.getInstance();
